import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import Theme from 'LegacyWeployDesignLanguage/Theme';

const CIRCULAR = 'circular';
const LINEAR = 'linear';

const CenteredItem = styled.div`
  text-align: center;
  padding: ${props => props.theme.space.double};
`;

const PaddedText = styled.div`
  margin-bottom: ${props => props.theme.spacing[1]};
`;

const LoaderContainer = styled.div`
  width: ${props => props.width};
  margin: auto;
`;

const CircularLoader = ({ classes }) => (
  <CircularProgress
    className={classes.progress}
    size={50}
    thickness={4}
  />
);

CircularLoader.propTypes = {
  classes: PropTypes.object.isRequired,
};

const StyledCircularLoader = withStyles({
  progress: {
    color: Theme.colors.weployAqua,
  },
})(CircularLoader);

const StyledLinearLoader = withStyles({
  colorPrimary: {
    backgroundColor: '#b2dfdb',
  },
  barColorPrimary: {
    backgroundColor: `${Theme.colors.brand.primary}`,
  },
})(LinearProgress);

const Loader = ({
  children,
  loading,
  text,
  width,
  type,
}) => {
  if (loading) {
    return (
      type === CIRCULAR
        ? (
          <CenteredItem>
            <StyledCircularLoader />
            <div>{text}</div>
          </CenteredItem>
        )
        : (
          <Fragment>
            <PaddedText>{text}</PaddedText>
            <LoaderContainer width={width}>
              <StyledLinearLoader />
            </LoaderContainer>
          </Fragment>
        )
    );
  }

  return children;
};

Loader.CIRCULAR = CIRCULAR;
Loader.LINEAR = LINEAR;

Loader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.object,
      PropTypes.string,
    ])),
    PropTypes.element,
  ]),
  loading: PropTypes.bool.isRequired,
  text: PropTypes.string,
  type: PropTypes.string,
  width: PropTypes.string,
};

Loader.defaultProps = {
  children: null,
  text: 'Loading...',
  type: CIRCULAR,
  width: '200px',
};

export default Loader;
